import React, { useState, useRef, useEffect } from 'react';
import './footer.css';
import '../Navbar/navbar.css';

const ElFooter = () => {
  const [showFullDisclaimer, setShowFullDisclaimer] = useState(false);
  const [characterLimit, setCharacterLimit] = useState(200);
  const disclaimerText =
    'Disclaimer: This Engage Portal (“the Engage”) is strictly for internal usage by KPOINT Technologies Private Limited (“KTPL”) and not for public circulation by any person having access to, unless otherwise expressly authorized by KTPL. The videos and other content (“Content”) hosted on the Engage, is intended only for demo purposes and showcase of tech capabilities by KTPL of its KPOINT Video Platform (“KPOINT”) to its prospects / customers. KTPL does not own the Content hosted on the Engage and further vouches that the Content is rather owned by the respective entities being customers of KTPL, using KPOINT to host their Content for their intended purposes. By hosting the Content on the Engage, KTPL does not intend to infringe the rights in such Content of the respective owners and is merely hosting it for brand building and sales pitching. Any person accessing the Engage and / or viewing the Content hosted thereon, agrees to the aforesaid disclaimer and that any misuse of the Content by such person, may attract legal action by KTPL and / or the respective owners of such Content, as the case may be.  '; // Your long disclaimer text goes here.

  const footerRef = useRef(null);

  useEffect(() => {
    const updateCharacterLimit = () => {
      setCharacterLimit(window.innerWidth <= 768 ? 50: 200);
    };

    updateCharacterLimit();
    window.addEventListener('resize', updateCharacterLimit);

    return () => {
      window.removeEventListener('resize', updateCharacterLimit);
    };
  }, []);

  const toggleShowMore = () => {
    setShowFullDisclaimer(!showFullDisclaimer);
    if (!showFullDisclaimer) {
      setTimeout(() => {
        footerRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 100); // Give some time for the UI to update before scrolling
    }
  };

  return (
    <div
      ref={footerRef}
      className="footer"
      style={{ maxHeight: showFullDisclaimer ? '64vh' : '50vh' }}
    >
      <div className="footer-container">
        <div className="footer-content">
          {showFullDisclaimer || disclaimerText.length <= characterLimit ? (
            <span className="footer-text">{disclaimerText}</span>
          ) : (
            <span className="footer-text">
              {`${disclaimerText.substring(0, characterLimit)}... `}
            </span>
          )}
          {disclaimerText.length > characterLimit && (
            <button onClick={toggleShowMore} className="toggle-button">
              {showFullDisclaimer ? 'Show Less' : 'Show More'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ElFooter;
